import { onCLS, onFCP, onLCP, onTTFB } from 'web-vitals';

import SegmentIO from 'reporting/SegmentIO';
import { SplunkReporter } from 'reporting/splunk/SplunkReporter';
import { isOutdatedBrowser, isMobile } from 'server/helpers/deviceInfo';
const splunkReporter = SplunkReporter.getInstance();
const logger = 'businessLogic/utils/performanceActions';
import { NavigationType, Metric } from 'types/SplunkLogs';

interface perfNavigator extends Navigator {
  userAgent: string;
  connection?: {
    supported: boolean;
  };
}

interface perfWindow extends Window {
  SSR_VISIBLE?: number;
  navigator: perfNavigator;
}

export const onDocumentStateComplete = async ({
  companyLocale,
  pageName,
  usedCache,
}: {
  companyLocale: string;
  pageName: string;
  usedCache: boolean;
}): Promise<void> => {
  try {
    const navigationEntries: PerformanceEntry[] = window.performance.getEntriesByType('navigation');
    const navigation: PerformanceEntry | { navigation: string } =
      navigationEntries.length > 0 ? navigationEntries[0] : { navigation: 'no navigation entries' };
    const perfWindow: perfWindow = global.window;
    const { navigator: { userAgent = 'unknown', connection = { supported: false } } = {} } =
      perfWindow;

    const isUnsupportedBrowser: boolean = isOutdatedBrowser(userAgent);
    const performanceReportMessage = {
      EventName: 'PerformanceReport',
      navigation,
      performance: window.performance,
      userAgent,
      isUnsupportedBrowser,
      isMobileDevice: isMobile(userAgent),
      connection,
      Locale: companyLocale,
      PageName: pageName,
      usedCache,
      ssrV2Visible: 0,
    };

    if (perfWindow.SSR_VISIBLE) {
      performanceReportMessage.ssrV2Visible = perfWindow.SSR_VISIBLE;
    }

    splunkReporter.contextual({
      logInfo: { logLevel: 'info', logger },
      event: 'viewSale',
      action: 'performanceReport',
      activityInfo: {
        pageName,
      },
      rum: {
        start: 0,
        end: 0,
        executionTimeMs: perfWindow.SSR_VISIBLE ? perfWindow.SSR_VISIBLE : 0,
      },
    });
  } catch (e) {
    splunkReporter.contextual({
      logInfo: { logLevel: 'error', logger },
      event: 'viewSale',
      action: 'performanceReport',
      activityInfo: {
        error: (e as Error).message,
        pageName,
      },
    });
  }
};

export const reportWebVitals = (pageName: string, options?: { isServedViaCdn?: boolean }) => {
  try {
    const isServedViaCdn = !!options?.isServedViaCdn;
    const reportMetric = (data: {
      name: Metric;
      navigationType: NavigationType;
      value: number;
    }) => {
      const { name: metric, navigationType, value: executionTimeMs } = data;
      splunkReporter.contextual({
        logInfo: { logLevel: 'info', logger },
        event: 'viewSale',
        action: 'reportWebVitals',
        activityInfo: {
          pageName,
          isServedViaCdn,
        },
        rum: {
          metric,
          navigationType,
          executionTimeMs,
        },
      });
      SegmentIO.trackWebPerformanceMetric({ metricType: metric, value: executionTimeMs });
    };

    onCLS(reportMetric);
    onTTFB(reportMetric);
    onLCP(reportMetric);
    onFCP(reportMetric);
    return;
  } catch (e) {
    return false;
  }
};
